import { type CustomCellRendererProps } from '@mint-lib/ag-grid/react';
import type { FC } from 'react';

import { useDateFormatter, useTimeFormatter } from '@mint-lib/formatting-hooks';
import { parseISO } from 'date-fns';

import type { ApprovalTableItemData } from '../../../types/approversTable.js';

type Props = CustomCellRendererProps<ApprovalTableItemData, string>;

const DateTimeCell: FC<Props> = ({ value }) => {
  const date = value ? parseISO(value) : null;
  const { formattedDateFrom } = useDateFormatter(date ?? undefined);
  const timeFormatter = useTimeFormatter();
  const formattedTime = date ? timeFormatter.format(date) : null;

  if (!formattedDateFrom || !formattedTime) {
    return null;
  }

  return `${formattedDateFrom} ${formattedTime}`;
};

export default DateTimeCell;
